function addMoreQty(itemCount){
  var addMore = document.getElementById('add-more');
  if (addMore){
    if( itemCount === 0 ) {
      addMore.innerHTML = "ADD 4 MORE AND SAVE $8";
    }else if(itemCount === 1){
      addMore.innerHTML = "ADD 3 MORE AND SAVE $8";
    }else if(itemCount === 2){
      addMore.innerHTML = "ADD 2 MORE AND SAVE $8";
    }else if(itemCount === 3){
      addMore.innerHTML = "ADD 1 MORE AND SAVE $8";
    }else if(itemCount === 4){
      addMore.innerHTML = "ADD 3 MORE AND SAVE $35";
    }else if(itemCount === 5){
      addMore.innerHTML = "ADD 2 MORE AND SAVE $35";
    }else if(itemCount === 6){
      addMore.innerHTML = "ADD 1 MORE AND SAVE $35";
    }else if(itemCount === 7){
      addMore.innerHTML = "ADD 3 MORE AND SAVE $80";
    }else if(itemCount === 8){
      addMore.innerHTML = "ADD 2 MORE AND SAVE $80";
    }else if(itemCount === 9){
      addMore.innerHTML = "ADD 1 MORE AND SAVE $80";
    }else if(itemCount > 9){
      addMore.innerHTML = "YOU HAVE SAVED $80";
    }
  }

  var progressMessage;
  if (itemCount === 1) {
    progressMessage = '.10';
  } else if (itemCount === 2) {
    progressMessage = '.20';
  } else if (itemCount === 3 ) {
    progressMessage = '.27';
  } else if (itemCount === 4 ) {
    progressMessage = '.37';
  } else if (itemCount === 5 ) {
    progressMessage = '.48';
  } else if (itemCount === 6 ) {
    progressMessage = '.59';
  } else if (itemCount === 7 ) {
    progressMessage = '.67';
  } else if (itemCount === 8 ) {
    progressMessage = '.78';
  } else if (itemCount === 9 ) {
    progressMessage = '.89';
  } else if (itemCount > 9 ) {
    progressMessage = '100';
  } else {
    progressMessage = '0';
  }
  // Product page shipping progress update by TT
  var progressBar = document.querySelector(".progress-bar");
  if(progressBar){
    progressBar.style.setProperty('--progress', progressMessage);
  }

}
function cartGet(){
  fetch('/cart.js', {
    method: 'GET'
  })
      .then((response) => {
        return response.json();
      })
      .then((parsedState) => {
        let itemCount = 0;
        console.log(parsedState)
        parsedState.items.forEach( function (e) {
          if ( e.product_type === 'MENUNDERWEAR' || e.product_type === 'MEN BAMBOO UNDERWEAR')
            itemCount += e.quantity;
        });
        console.log(parseInt(itemCount))

        //addMoreQty(itemCount)
      })
}
cartGet();

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();

      if (this.querySelector("cart-recommendation")){
        this.querySelector("cart-recommendation").style.display = "block"
      }

      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {

    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
              ? this.querySelector('.drawer__inner-empty')
              : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
    );

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden-active');
  }

  close() {
    if (this.querySelector("cart-recommendation")){
      this.querySelector("cart-recommendation").style.display = "none"
    }
    document.querySelector('cart-drawer').classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden-active');
      //this.open();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {

    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);


      if (document.querySelector("cart-recommendation")){
        document.querySelector("cart-recommendation").style.display = "block"
      }
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    cartGet();
  }

  renderContentsMobileDrawer(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      //this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'bulk-discount-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'bulk-discount-bubble',
        section: 'bulk-discount-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Cart recommendation product by TT
if(!customElements.get('cart-recommendation')) {
  customElements.define(
      'cart-recommendation',
      class CartRecommendation extends HTMLElement {
        constructor() {
          super();

          this.initSwiper();
        }

        initSwiper() {
          this.swiperSlides = parseFloat(this.getAttribute('data-slides'));
          this.swiperSlidesMobile = parseFloat(this.getAttribute('data-slides-mobile'));
          this.swiperSlidesGap = parseFloat(this.getAttribute('data-slides-gap'));
          this.swiper = new Swiper(this.querySelector('[id^="SwiperCartRecommendation"]'), {
            slidesPerView: this.swiperSlidesMobile,
            spaceBetween: this.swiperSlidesGap,
            // And if we need scrollbar
            scrollbar: {
              el: this.querySelector('[id^="swiper-scrollbar"]'),
              draggable: true
            },
            freeMode: true,
            freeModeMomentum: true,
            speed: 4500,
            breakpoints: {
              750: {
                slidesPerView: this.swiperSlides,
                spaceBetween: this.swiperSlidesGap,
              }
            }
          });
        }
      }
  )
}

// Free gift product by TT
class freeGiftButton extends CartItems{
  constructor() {
    super();

    this.querySelector('.free-gift-button').addEventListener('click', this.open.bind(this));
  }

  open(){
    document.getElementById('free-gift-products').style.display = "block";
    document.getElementById('free-gift-products').classList.add('is--open');
  }
}
customElements.define('free-gift-button',freeGiftButton);

class freeGiftProduct extends HTMLElement{
  constructor() {
    super();
    this.querySelector('.free-gift-product-header').addEventListener('click', this.close.bind(this));
  }
  close(){
    document.getElementById('free-gift-products').style.display = "none"
    document.getElementById('free-gift-products').classList.remove('is--open');
  }
}
customElements.define('free-gift-products',freeGiftProduct);